import React, { useState, useEffect } from "react";
import { Row, Col, Button, Spinner, Card } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import ApiAmusementService from "../../../core/api/api.amusementService";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import { Link, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import ShowImages from "./ShowImages/ShowImages";
import { NumericFormat } from "react-number-format";
import TextEditor from "../_Components/CkEditor/Index";
import SelectComponent from "../_Components/ReactSelectComponent";
import { useNavigate } from "react-router-dom";
import AddImageLabelModal from "./AddImageLabelModal";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import Swal from "sweetalert2";
import ApiRegion from "../../../core/api/api.region";
import { numberWithDotRegex, tools } from "../../../core/utils/tools";

const CreateEditAmusementService = () => {
  //const { register, handleSubmit, control, formState: { errors }, getValues, setValue } = useForm({defaultValues: { id: 0 }});
  const navigate = useNavigate();
  const {
    handleSubmit: handleSubmit2,
    control: control2,
    formState: { errors: errors2, isSubmitting },
    getValues: getValues2,
    setValue: setValue2,
  } = useForm({ defaultValues: { id: 0 } });

  //    const { match } = props;
  let { id } = useParams();
  const [groups, setGroups] = useState([]);
  const [allAmusementCityList, setAllAmusementCityList] = useState([]);
  const [showImageLabelModal, setShowImageLabelModal] = useState(false);

  const [imageLabels, setImageLabels] = useState([]);
  const [selectedImageLabel, setSelectedImageLabel] = useState([]);
  const [selectedImageLabelId, setSelectedImageLabelId] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        // دریافت لیست مکانهای تفریح
        //const amusementPlaces = await ApiAmusementPlace.getAll({ PageNumber: 1, PageSize: 400 });
        //setAllAmusementPlaceList(amusementPlaces.data)

        // دریافت لیست گروه های تفریح
        const amusementGroups = await ApiAmusementGroup.getAllGroups();
        setGroups(amusementGroups);

        if (id && id != 0) {
          const response = await ApiAmusementService.get(id);
          if (response.succeeded === true) {
            setAllAmusementCityList(response.data.cityList);
            setValue2("id", response.data.id);
            setValue2("alerts", response.data.alerts);
            setValue2("imageUrl", response.data.imageUrl);
            setValue2("name", response.data.name);
            setValue2("title", response.data.title);
            setValue2("nameEn", response.data.nameEn);
            setValue2("urlName", response.data.urlName);
            setValue2("metaDescription", response.data.metaDescription);
            setValue2("metaKeywords", response.data.metaKeywords);
            setValue2("pageTitle", response.data.pageTitle);
            setValue2("status", response.data.status);
            setValue2("tafrihanSuggestion", response.data.tafrihanSuggestion);
            setValue2("isPopular", response.data.isPopular);
            setValue2("description", response.data.description);
            setValue2("price", response.data.price);
            setValue2("originalPrice", response.data.originalPrice);
            setValue2("lat", response.data.lat);
            setValue2("lon", response.data.lon);
            setValue2("address", response.data.address);
            // setValue2("amusementGroupId", response.data.amusementGroupId);

            setValue2(
              "amusementCityList",
              response.data.amusementServiceRegions.map((item) => ({
                value: item.region.id,
                label: item.region.id + "-" + item.region.name,
                labelId: item.id,
              })),
            );
            setValue2(
              "amusementGroupId",
              response.data.amusementServiceAmusementGroups.map((item) => ({
                value: item.amusementGroup.id,
                label: item.amusementGroup.id + "-" + item.amusementGroup.title,
                labelId: item.id,
                amusementServiceIndexView: item.amusementServiceIndexView,
              })),
            );
            setValue2("showInHomePage", response.data.showInHomePage);
            setValue2("isNoIndex", response.data.isNoIndex);
            setValue2("hideInAmusementGroupPage", response.data.hideInAmusementGroupPage);
            setValue2("suggestedPromoCode", response.data.suggestedPromoCode);
            const imageLabelJson = JSON.parse(response?.data?.imageLabelJson || "[]");
            setValue2("imageLabelList", imageLabelJson);
            setImageLabels(imageLabelJson);
          }
        } else {
          setValue2("id", 0);
          const response = await ApiRegion.getAllCity();
          setAllAmusementCityList(response);
        }
      } catch (error) {
      }
    })();
  }, []);

  const onSubmit2 = async (data) => {
    data.originalPrice =
      data.originalPrice && data.originalPrice.length > 0
        ? data.originalPrice.replaceAll(" ", "").replaceAll(",", "")
        : data.originalPrice;
    data.price = data.price && data.price.length > 0 ? data.price.replaceAll(" ", "").replaceAll(",", "") : data.price;
    try {
      if (data.amusementCityList?.length > 0) {
        let amusementCityListObj = [];
        let tt = data.amusementCityList?.map((item) => {
          amusementCityListObj.push({ CityId: item.value, serviceRegionRelationId: item.labelId });
        });

        data.amusementCityList = amusementCityListObj;
      }

      if (data.amusementGroupId?.length > 0) {
        const amusementGroupListObj = data.amusementGroupId.map((item) => ({
          groupId: item.value,
          amusementServiceIndexView: item.amusementServiceIndexView,
        }));
        data.amusementGroupList = amusementGroupListObj;
      }
      let response = null;

      // return
      if (data.id <= 0) {
        response = await ApiAmusementService.create(data);
        if(response.succeeded){
        navigate(`/amusementService`);
      }
      } else response = await ApiAmusementService.update(data.id, data);
      // برای رفرش کردن لیست در حالتی که فرم مدال استفاده شود
      // if (response.succeeded === true)
      //     (document.getElementById('submitButton')).click();
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  function handleChangeMultiCity(value, selectItem) {
    setValue2("amusementCityList", value);
    let id = [];
    if (!_.isEmpty(getValues2("amusementCityList"))) {
      getValues2("amusementCityList").map((item) => id.push(item.value));
    }
  }

  function createUrlAddress() {
    const englishName = getValues2("nameEn");
    const urlName = englishName
      .replace(/[,!?'@]/g, "")
      .replace(/\s+/g, "-")
      .toLowerCase();
    setValue2("urlName", urlName);
  }
  const handleDeleteImageLabel = (index) => {
    Swal.fire({
      title: "عملیات حذف برچسب عکس",
      text: "ایا قصد حذف این برچسب عکس را دارید؟",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      cancelButtonText: "انصراف",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then((result) => {
      if (result.isConfirmed) {
        const filteredImageLabels = imageLabels.filter((item, i) => i !== index);
        setImageLabels(filteredImageLabels);
        setValue2("imageLabelList", [...filteredImageLabels]);
      } else if (result.isDenied) {
      }
    });
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              {id && id !== "0" ? "ویرایش سرویس" : " ایجاد سرویس جدید"}
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              {id && id !== "0"
                ? "برای ویرایش سرویس  فرم زیر را اصلاح نمایید"
                : "برای افزودن سرویس جدید، فرم زیر را تکمیل نمایید"}
            </span>
          </h3>
        </div>
        {/*Start body */}
        <form key={2} id="form2" onSubmit={handleSubmit2(onSubmit2)}>
          <div className="card-body pt-3 pb-0 border-top">
            <div>
              <h6>مشخصات سرویس</h6>
              <Row>
                <Col lg="6" xs="12">
                  {" "}
                  <Controller
                    name="name"
                    control={control2}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام سرویس"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors2.name && <small className="text-danger">لطفا نام سرویس را وارد نمایید !</small>}
                </Col>
                <Col lg="6" xs="12">
                  {" "}
                  <Controller
                    name="title"
                    control={control2}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="عنوان"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors2.title && <small className="text-danger">لطفا عنوان را وارد نمایید !</small>}
                </Col>
              </Row>
              <Row>
                <Col lg="6" xs="12">
                  {" "}
                  <Controller
                    name="nameEn"
                    control={control2}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <Row className="align-items-center">
                        <Col xs className="pr-0">
                          <TextField
                            label="نام انگلیسی"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            value={value || ""}
                            onInput={onChange}
                          />
                        </Col>
                        <Col xs="auto" className="pl-1">
                          <Button
                            variant="primary"
                            className="mt-2"
                            style={{ height: "39px" }}
                            onClick={createUrlAddress}
                            disabled={!getValues2("nameEn")}
                          >
                            ایجاد آدرس
                          </Button>
                        </Col>
                      </Row>
                    )}
                  />
                  {errors2.nameEn && <small className="text-danger">لطفا نام انگلیسی را وارد نمایید !</small>}
                </Col>
                <Col lg="6">
                  {" "}
                  <Controller
                    name="urlName"
                    control={control2}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="urlName"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors2.urlName && <small className="text-danger">لطفا urlName را وارد نمایید !</small>}
                </Col>


              </Row>
              <Row>
                <Col lg="6">
                  {" "}
                  <Controller
                    name="imageUrl"
                    control={control2}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="عکس شاخص"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors2.imageUrl && <small className="text-danger"> لطفا عکس شاخص را وارد نمایید !</small>}
                </Col>
                <Col lg="6">
                  {" "}
                  <Controller
                    name="metaKeywords"
                    control={control2}
                    rules={{ required: false }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="metaKeywords"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  {" "}
                  <Controller
                    name="metaDescription"
                    control={control2}
                    rules={{ required: false }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="metaDescription"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />{" "}
                </Col>
                <Col lg="6">
                  {" "}
                  <Controller
                    name="pageTitle"
                    control={control2}
                    rules={{}}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="عنوان صفحه"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />{" "}
                </Col>
              </Row>
            </div>
            <Row className="">
              <Col lg="6" xs="12">
                {/* <Col>
                  <h6>شهر های ارائه دهنده سرویس</h6>
                </Col>{" "} */}
                <Controller
                  name="amusementCityList"
                  control={control2}
                  render={({ field }) => (
                    <SelectComponent
                      className="mt-5"
                      placeholder="شهرهای ارائه دهنده سرویس"
                      options={allAmusementCityList?.map((item) => ({
                        value: item.id,
                        label: item.id + "-" + item.name,
                      }))}
                      isMulti
                      field={field}
                      onChange={handleChangeMultiCity}
                    />
                  )}
                />
              </Col>
              <Col lg="6" xs="12">
                {/* <Col>
                    <h6>گروه</h6>
                  </Col>{" "} */}
                <Controller
                  name="amusementGroupId"
                  control={control2}
                  render={({ field }) => (
                    <SelectComponent
                      className="mt-5"
                      placeholder="گروه"
                      options={groups?.map((item) => ({
                        value: item.id,
                        label: item.id + "-" + item.title,
                      }))}
                      field={field}
                      isMulti
                    />
                  )}
                />
                {errors2.amusementGroupId && <small className="text-danger">لطفا گروه را وارد نمایید !</small>}
              </Col>
            </Row>
            <Row>
              <Col xs="12" lg="6" className="mt-5">
                {/* {" "}
                <h6> قیمت اصلی </h6> */}
                <Controller
                  name="originalPrice"
                  control={control2}
                  defaultValue="0"
                  render={({ field: { onChange, value } }) => (
                    <NumericFormat
                      customInput={TextField}
                      label="قیمت اصلی"
                      variant="outlined"
                      size="small"
                      type="search"
                      value={value || ""}
                      onChange={onChange}
                      thousandSeparator=","
                      className="w-100 mt-0"
                      onKeyDown={(e) => {
                        if (e.key === "Escape") {
                          e.stopPropagation()
                        }
                      }}
                    />
                  )}
                />
              </Col>
              <Col xs="12" lg="6" className="mt-5">
                {/* {" "}
                <h6> قیمت </h6> */}
                <Controller
                  name="price"
                  control={control2}
                  defaultValue="0"
                  render={({ field: { onChange, value } }) => (
                    <NumericFormat
                      customInput={TextField}
                      label="قیمت"
                      variant="outlined"
                      type="search"
                      size="small"
                      value={value || ""}
                      onChange={onChange}
                      thousandSeparator=","
                      className="w-100"
                      onKeyDown={(e) => {
                        if (e.key === "Escape") {
                          e.stopPropagation()
                        }
                      }}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col xs="12" lg="6" className="mt-5">
                <Controller
                  name="lat"
                  control={control2}
                  rules={{
                    validate: (value) => tools.locationValidation(value, getValues2("lon")).latValidation
                  }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="Lat"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      onInput={(event) => {
                        const parts = event.target?.value.replace(/[^0-9\u06F0-\u06F9.]/g, "").replace(/٫/g, ".").split(".");
                        if (event.target?.value && (event.target?.value.length > 20 || numberWithDotRegex.test(event.target?.value) || parts.length > 2)) {
                          event.target.value = getValues2("lat")
                          return
                        }
                        onChange(event)
                      }}
                      value={value || ""}
                    />
                  )}
                />
                <small className="text-danger">{errors2.lat?.message}</small>
              </Col>

              <Col xs="12" lg="6" className="mt-5">
                <Controller
                  name="lon"
                  control={control2}
                  rules={{
                    validate: (value) => tools.locationValidation(getValues2("lat"), value).lonValidation
                  }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="Lon"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      onInput={(event) => {
                        const parts = event.target?.value.replace(/[^0-9\u06F0-\u06F9.]/g, "").replace(/٫/g, ".").split(".");
                        if (event.target?.value && (event.target?.value.length > 20 || numberWithDotRegex.test(event.target?.value) || parts.length > 2)) {
                          event.target.value = getValues2("lon")
                          return
                        }
                        onChange(event)
                      }}
                      value={value || ""}
                    />
                  )}
                />
                <small className="text-danger">{errors2.lon?.message}</small>
              </Col>

            </Row>
            <Row>
              <Col xs="12" sm="6" className="">
                <Controller
                  name="address"
                  control={control2}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="آدرس"
                      type="text"
                      rows={2}
                      multiline
                      variant="outlined"
                      margin="normal"
                      className=""
                      value={value || ""}
                      onInput={onChange}
                      sx={{
                        ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                          padding: "8.5px 14px 8.5px 0px !important",
                        }
                      }}
                    />
                  )}
                />
              </Col>
              <Col xs="12" lg="6" className="mt-5">
                <Controller
                  name="suggestedPromoCode"
                  control={control2}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="کد تخفیف پیشنهادی"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                    />
                  )}
                />
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs="12">
                {" "}
                <h6 className="my-5">نکات مهم و ضروری</h6>
                <Controller
                  name="alerts"
                  control={control2}
                  render={({ field: { onChange, value } }) => (
                    <TextEditor
                      data={value || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        onChange(data);
                        setValue2("alerts", data);
                      }}
                    />
                  )}
                />
              </Col>
              <Col xs="12" className="mt-5">
                {" "}
                <h6 className="my-5">بررسی اجمالی</h6>
                <Controller
                  name="description"
                  control={control2}
                  render={({ field: { onChange, value } }) => (
                    <TextEditor
                      data={value || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        onChange(data);
                        setValue2("description", data);
                      }}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="7" lg="6" className="px-0 mt-5">
                <div>
                  <FormControlLabel
                    control={
                      <Controller
                        control={control2}
                        name={"status"}
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                          fieldState: { invalid, isTouched, isDirty, error },
                        }) => (
                          <Checkbox
                            color="primary"
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value || false}
                            inputRef={ref}
                          />
                        )}
                      />
                    }
                    label="فعال"
                  />
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Controller
                        control={control2}
                        name={"showInHomePage"}
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                          fieldState: { invalid, isTouched, isDirty, error },
                        }) => (
                          <Checkbox
                            color="primary"
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value || false}
                            inputRef={ref}
                          />
                        )}
                      />
                    }
                    label="نمایش در صفحه اصلی"
                  />
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Controller
                        control={control2}
                        name={"hideInAmusementGroupPage"}
                        render={({ field: { onChange, onBlur, value, ref } }) => (
                          <Checkbox
                            color="primary"
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value || false}
                            inputRef={ref}
                          />
                        )}
                      />
                    }
                    label="عدم نمایش در صفحه دسته بندی"
                  />
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Controller
                        control={control2}
                        name={"tafrihanSuggestion"}
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                          fieldState: { invalid, isTouched, isDirty, error },
                        }) => (
                          <Checkbox
                            color="primary"
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value || false}
                            inputRef={ref}
                          />
                        )}
                      />
                    }
                    label="پیشنهاد تفریحان"
                  />
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Controller
                        control={control2}
                        name={"isPopular"}
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                          fieldState: { invalid, isTouched, isDirty, error },
                        }) => (
                          <Checkbox
                            color="primary"
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value || false}
                            inputRef={ref}
                          />
                        )}
                      />
                    }
                    label="تفریح پرطرفدار"
                  />
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Controller
                        control={control2}
                        name={"isNoIndex"}
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                          fieldState: { invalid, isTouched, isDirty, error },
                        }) => (
                          <Checkbox
                            color="primary"
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value || false}
                            inputRef={ref}
                          />
                        )}
                      />
                    }
                    label="توسط گوگل ایندکس نشود"
                  />
                </div>
              </Col>
            </Row>
          </div>

          <div className="px-5 mt-3">
            <Button
              className="btn btn-primary"
              onClick={() => {
                setShowImageLabelModal(true);
                setSelectedImageLabel({});
              }}
            >
              <AddCircle className="mr-1" />
              افزودن برچسب عکس
            </Button>
          </div>
          {imageLabels?.length > 0 ? (
            <div className="px-5">
              <Row>
                {imageLabels?.map((item, index) => (
                  <Col key={index} xs="12" sm="6" lg="4" className="mt-5">
                    <Card className="h-100" style={{ borderColor: "#ccc" }}>
                      <Card.Body className="p-3">
                        <div className=" mb-3">
                          <div className="fw-bold pl-1 mb-2">عنوان برچسب: </div>
                          <div dangerouslySetInnerHTML={{ __html: item.LabelText }}></div>
                        </div>
                      </Card.Body>
                      <Card.Footer className="p-3">
                        <Button
                          className="btn btn-light-primary btn-sm mr-2 btn-icon"
                          onClick={() => {
                            setShowImageLabelModal(true);
                            setSelectedImageLabel(item);
                            setSelectedImageLabelId(index);
                          }}
                        >
                          <i className="far fa-edit text-small"></i>
                        </Button>
                        <Button
                          className="btn btn-light-danger btn-sm btn-icon"
                          onClick={() => {
                            handleDeleteImageLabel(index);
                          }}
                        >
                          <i className="far fa-trash-alt text-small"></i>
                        </Button>
                      </Card.Footer>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          ) : (
            <div className="my-3 pl-6">هیچ برچسبی ثبت نشده است.</div>
          )}
          <div className=" mx-5 mt-5">
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Link className="btn btn-danger ml-3" to="/amusementService">
              <CloseIcon /> بازگشت
            </Link>
          </div>
        </form>
        {showImageLabelModal && (
          <AddImageLabelModal
            showImageLabelModal={showImageLabelModal}
            setShowImageLabelModal={setShowImageLabelModal}
            setImageLabels={setImageLabels}
            selectedImageLabel={selectedImageLabel}
            setValue={setValue2}
            selectedImageLabelId={selectedImageLabelId}
            imageLabels={imageLabels}
          />
        )}
        <Row>
          <Col>
            <ShowImages amusementServiceId={id} />
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default CreateEditAmusementService;
